import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import NewCustomerButton from '../../components/dashboard/NewCustomerButton';
import UserContext from '../../context/user-context';
import CustomerSearch from '../../components/customer/CustomerSearch/CustomerSearch';
import styles from './Dashboard.module.css';
import Sidebar from '../../components/layout/Sidebar/Sidebar';

function Dashboard() {
  const userCtx = useContext(UserContext);
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {userCtx.isLoggedIn && (
        <>
          <Sidebar />
          <div className={styles.customerActions}>
            <div className={styles.pageTitle}>
              {t('pages.dashboard')}
            </div>
            <div className={styles.newCustomer}>
              <NewCustomerButton />
            </div>
            <div className={styles.break} />
            <div className={styles.customerSearch}>
              <CustomerSearch />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Dashboard;
